<div class="container">
  <!--<router-outlet></router-outlet>-->

  <ng-container [ngSwitch]="route">
    <div *ngIf="isCoverpath">
      <bene-list
        *ngSwitchCase="'bene-list'"
        [policyType]="policyType"
        [policyNumber]="policyNumber"
        [dismiss]="dismiss"
      ></bene-list>
    </div>
    <div *ngIf="!isCoverpath">
      <bene-list *ngSwitchCase="'bene-list'" [policyType]="policyType" [dismiss]="dismiss"></bene-list>
    </div>
    <bene-form *ngSwitchCase="'pForm'" [dismiss]="dismiss" [type]="'Primary'"></bene-form>
    <bene-form *ngSwitchCase="'cForm'" [dismiss]="dismiss" [type]="'Contingent'"></bene-form>
    <bene-form *ngSwitchCase="'eForm'" [dismiss]="dismiss" [type]="'Edit'"></bene-form>
    <custodian *ngSwitchCase="'custodian'" [dismiss]="dismiss" [type]="'custodian'"></custodian>
    <print-form *ngSwitchCase="'printForm'"></print-form>
  </ng-container>
</div>
